// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://uqjjisbrbasocuhmbviz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVxamppc2JyYmFzb2N1aG1idml6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc2MTA4MjUsImV4cCI6MjA3MzE4NjgyNX0.SMptj5EG5De3MbCfwmmGbyoqDPoiaYjeASrVX0UvLmc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});